import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getStationeryReturnById } from 'src/redux/slices/stationery-return';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';
import StationeryReturnNewEditForm from '../stationery-return-new-edit-form';

type Props = {
  id: string;
};

export default function StationeryReturnEditView({ id }: Props) {
  const {
    return: currentReturn,
    status,
    error,
  } = useAppSelector((state) => state.stationeryReturn);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getStationeryReturnById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load return details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.stationeryReturn.root}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Returns
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  if (status === 'success' && currentReturn) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Edit Return"
          links={[
            {
              name: 'Return',
              href: paths.dashboard.stationeryReturn.root,
            },
            { name: 'Edit Return' },
          ]}
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <StationeryReturnNewEditForm currentReturn={currentReturn} />
      </Container>
    );
  }

  return <span />;
}
